api_bootstrap = angular.module 'bootstrap', ['ksc']

api_bootstrap.service 'api/BootStrap', [
  'ksc.BatchLoader',
  (BatchLoader) ->

# webapp api url prefix
    url = '/dashboard-calendar-ui/api/'

    bootstrap = new BatchLoader url + 'BootStrap',
      ApptReason: url + 'AppointmentReason'
      DailyApptCount: url + 'Appointment/counts'
      Location: url + 'ServiceLocation'
      OfficeHr: url + 'OfficeHours'
# OutstandingTasks: url + 'OutstandingTasks' # not yet in BootStrap
      Practice: url + 'Practice'
      PracticeFeatures: url + 'FeatureToggle'
      Privilege: url + 'Privileges'
      Pref: url + 'Practice/setting'
      Pro: url + 'Provider'
      RecentChart: url + 'User/recentcharts'
      Resource: url + 'Resource'
      User: url + 'User'

    setTimeout ->
      bootstrap.open = false # triggers loading
    , 5

    bootstrap
]
